import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import type { ILoaderData } from "@pages/panelPages/doctorProfile/doctorProfile";
import { useUIStore } from "@/stores/uiStore";

export const profileDoctorRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.profileDoctor.route,
      lazy: () => import("@pages/panelPages/doctorProfile/doctorProfile"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.doctor-profile", [], "create");
        return { id: params.id! };
      },
    },
    permissions: ["patient", "staff"],
  },
];
